import { useCallback } from 'react'

import useAlert from 'store/common/useAlert'
import Auth from 'store/auth'

import { subscribe, unsubscribe } from 'pages/api/rest/webinarSubscription'
import { AlertType, AlertSubscriptionText } from 'constants/alert'
import { congressTag, congressWebinarIds } from 'components/congress/congress-data'

const useWebinarSubscription = () => {
  const { setSingleAlert } = useAlert()
  const { setCurrentProfile } = Auth.useHandleAuth()
  const { userProfile } = Auth.useAuth()

  const unsubscribeWebinar = useCallback(async (webinarId: number | string) => {
    try {
      await unsubscribe(webinarId)
      setSingleAlert({
        type: AlertType.UNSUB_SUCCESS,
        text: AlertSubscriptionText[AlertType.UNSUB_SUCCESS],
        id: String(webinarId),
      })
    } catch {
      setSingleAlert({
        type: AlertType.SUB_ERROR,
        text: AlertSubscriptionText[AlertType.SUB_ERROR],
        id: String(webinarId),
      })
      throw Error
    }

    // if (congressWebinarIds.includes(Number(webinarId))) {
    //   const tagsModified =
    //     userProfile?.tags?.filter((tag: string) => tag !== congressTag) || []
    //   setCurrentProfile({
    //     ...userProfile,
    //     tags: tagsModified,
    //   })
    // }
  }, [])

  const subscribeWebinar = useCallback(async (webinarId: number | string) => {
    try {
      await subscribe(webinarId)
      setSingleAlert({
        type: AlertType.SUB_SUCCESS,
        text: AlertSubscriptionText[AlertType.SUB_SUCCESS],
        id: String(webinarId),
      })
    } catch {
      setSingleAlert({
        type: AlertType.SUB_ERROR,
        text: AlertSubscriptionText[AlertType.SUB_ERROR],
        id: String(webinarId),
      })
      throw Error
    }

    if (congressWebinarIds.includes(Number(webinarId))) {
      setCurrentProfile({
        ...userProfile,
        tags: [...(userProfile?.tags || []), congressTag],
      })
    }
  }, [])

  return { subscribeWebinar, unsubscribeWebinar }
}

export default useWebinarSubscription
